<!-- Vue 2 basic button for testing -->
<template>
	<v-btn
		:block="block"
		:color="color"
		:dark="dark"
		:dense="dense"
		:depressed="depressed"
		:disabled="disabled"
		:fab="fab"
		:href="href"
		:icon="icon"
		:light="light"
		:outlined="outlined"
		:ripple="ripple"
		:tabindex="tabindex"
		:target="target"
		:x-small="xSmall"
		:small="small"
		:medium="medium"
		:large="large"
		:x-large="xLarge"
		:text="text"
		:width="width"
		:value="value"
		v-bind="mergedAttrs"
		v-on="unhandled_events"
		@click="($event) => on_click($event)"
	>
		<slot></slot>
	</v-btn>
</template>

<script>
export default {
	inheritAttrs: false,
	props: {
		block: Boolean,
		color: String,
		dark: Boolean,
		dense: Boolean,
		depressed: Boolean,
		disabled: Boolean,
		fab: Boolean,
		href: String,
		icon: Boolean,
		light: Boolean,
		outlined: Boolean,
		ripple: [Boolean, Object],
		tabindex: [String, Number],
		target: String,
		xSmall: Boolean,
		small: Boolean,
		medium: Boolean,
		large: Boolean,
		xLarge: Boolean,
		text: Boolean,
		width: [String, Number],
		value: [String, Number, Boolean],
		accessibleLabel: {
			type: String,
			default: undefined
		}
	},
	computed: {
		mergedAttrs() {
			const attrs = { ...this.$attrs }
			if (this.accessibleLabel && !attrs['aria-label'] && !attrs['aria-labelledby']) {
				attrs['aria-label'] = this.accessibleLabel
			}
			return attrs
		},
		unhandled_events() {
			const { click, ...rest } = this.$listeners;
			return rest;
		}
	},
	methods: {
		on_click(event) {
			event.stopPropagation()
			this.$emit('click', event)
		},
		warnIfIconButtonNeedsLabel() {
			if (!this.icon) return
			const attrs = this.$attrs || {}
			const hasAccessibleName = Boolean(
				this.accessibleLabel
				|| attrs['aria-label']
				|| attrs['aria-labelledby']
				|| attrs.title
			)
			const text = (this.$el?.textContent || '').trim()
			if (!hasAccessibleName && !text) {
				console.warn('[KBtn] Icon-only buttons should include an accessible name via aria-label, aria-labelledby, or title.')
			}
		}
	},
	mounted() {
		this.warnIfIconButtonNeedsLabel()
	},
	updated() {
		this.warnIfIconButtonNeedsLabel()
	}
};
</script>
